module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-10-823aa16d85032c5a812d3e0e98ce07de.jpg";